import {ERROR_BOUNDARY_MESSAGE, ErrorCode} from '@/services/ErrorsService/ErrorsService.constants';

import {uuid4} from '@specials/project-user';

interface FrontendErrorData {
  errorCode: string;
  message: string;
  requestId: string;
  timestamp: string;
  error: Error;
}

const FRONTEND_ERROR_NAME = 'FrontendError';

export class FrontendError extends Error {
  public readonly errorCode: string;
  public readonly message: string;
  public readonly requestId: string;
  public readonly timestamp: string;
  public readonly error: Error;
  public readonly isFrontendError: true;
  public readonly name: string;

  constructor(errorData: FrontendErrorData) {
    super(errorData.message);
    this.errorCode = errorData.errorCode;
    this.message = errorData.message;
    this.requestId = errorData.requestId;
    this.timestamp = errorData.timestamp;
    this.error = errorData.error;
    this.isFrontendError = true;
    this.name = FRONTEND_ERROR_NAME;
  }

  public static isFrontendError = (error: unknown): error is FrontendError => {
    if (!error) {
      return false;
    }

    return typeof error === 'object' && 'isFrontendError' in error;
  };

  public static createBoundaryError = (error: Error): FrontendError => {
    return new FrontendError({
      errorCode: ErrorCode.BoundaryError,
      message: ERROR_BOUNDARY_MESSAGE,
      requestId: uuid4(),
      timestamp: new Date().toISOString(),
      error,
    });
  };
}
